import request from "@/router/axios";
// 整改列表
export const getList = (params) => {
  return request({
    url: "/api/produce/safety-hazard-rectify/select/page",
    method: "post",
    data: params,
  });
};
export const exportExcel = (params) => {
  return request({
    url: "/api/produce/safety-hazard-rectify/export/excel",
    method: "post",
    data: params,
    responseType: "blob",
  });
};
// 查询检查表
export const getCheckList = (params) => {
  return request({
    url: "/api/produce/safety-check-plan/select/page",
    method: "post",
    data: params,
  });
};
export const add = (row) => {
  return request({
    url: "/api/produce/safety-check-record/insert",
    method: "post",
    data: row,
  });
};
export const getUserList = () => {
  return request({
    url: "/api/produce/blade-user/select/userList",
    method: "post",
    params: {},
  });
};

export const getDeptTree = () => {
  return request({
    url: "/api/produce/blade-dept/select/deptSelect",
    method: "get",
  });
};


export const update = (row) => {
  return request({
    url: "/api/produce/safety-check-list/update",
    method: "post",
    data: row,
  });
};
export const getDetail = (id) => {
  return request({
    url: '/api/produce/safety-check-record/getDetail/id',
    method: 'get',
    params: {
      id
    }
  })
}
export const remove = (id) => {
  return request({
    url: '/api/produce/safety-hazard-rectify/delete/id',
    method: 'get',
    params: {
      id
    }
  })
}

export const changeStatus = (id, type) => {
  return request({
    url: `/api/produce/safety-check-list/${type}/id`,
    method: 'post',
    params: {
      id
    }
  })
}

// 整改验收
export const acceptance = (params) => {
  return request({
    url: '/api/produce/safety-hazard-rectify/confirm/acceptance',
    method: 'post',
    data: params
  })
}

// 整改确认
export const rectifyConfirm = (data) => {
  return request({
    url: '/api/produce/safety-hazard-rectify/rectifyConfirm',
    method: 'post',
    data
  })
}

// 整改统计
export const getCardData = (params) => {
  return request({
    url: '/api/produce/safety-hazard-rectify/statistics/rectify-status',
    method: 'get',
    params
  })
}

export const getSafetyHazardRectifyDetail = (id) => {
  return request({
    url: "/api/produce/safety-hazard-rectify/select/id",
    method: "get",
    params: {id},
  });
};
